import dynamic from 'next/dynamic';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { ContactInformationProps } from './ContactInformation.types';

export const ContactInformation = dynamic<ContactInformationProps>(
  () => import('./ContactInformation').then(module => module.ContactInformation),
  {
    loading: () => <Skeleton count={5} />,
  }
);
